import React from 'react';
import { connect } from 'react-redux';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import SupportPopup from 'apps/auth/components/utils/popup/SupportPopup';
import { AUTH_PLUS_MAIN_PAGE } from 'apps/auth/constants/UrlConstants';

const Failed = (props) => {
    return (
        <InfoPage
            animatedIconFail
            mainText={props.headerTitle}
            buttonRowCaption={props.statusSupportTitle}
            buttonRowOnClick={(e) => {
                e.preventDefault();
                props.popupRef.current?.open(<SupportPopup popupRef={props.popupRef} />);
            }}
            primaryButtonCaption={props.statusCancelTitle}
            primaryButtonType="link"
            primaryButtonLink={AUTH_PLUS_MAIN_PAGE}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        headerTitle: state.messages.pageMessages.headerTitle,
        statusSupportTitle: state.messages.pageMessages.statusSupportTitle,
        statusCancelTitle: state.messages.pageMessages.statusCancelTitle,
    };
};

export default connect(mapStateToProps, null)(Failed);
